var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-350b4003.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-42970741.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M16 0v16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M4.288 2.402 8 6.114 14.065.05A56.78 56.78 0 0 1 16 0v1.886L9.886 8 16 14.114V16h-1.886L8 9.886 1.886 16H.003v-.017c-.008-.614 0-1.249.027-1.898L6.114 8 2.467 4.353a9.023 9.023 0 0 1 1.821-1.95Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M14.555.031C15.035.015 15.518.004 16 0L8.472 7.529l-.708-.708 6.791-6.79ZM3.308 3.307l4.22 4.222-.706.707-4.157-4.157c.194-.26.408-.52.643-.772ZM.003 16v-.003L7.53 8.47l.707.708L1.414 16H.004Zm8.469-7.529.707-.707L16 14.586V16L8.472 8.471Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M10 .399V16H6V1.372c.112-.05.226-.097.342-.143C7.272.876 8.544.6 10 .4Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M1.529 6H16v4H.442a30.35 30.35 0 0 1 .424-2.125s.169-.803.663-1.875Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M9.334.498V16H6.667V1.114C7.403.867 8.312.662 9.334.498Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M1.246 6.667H16v2.666H.558c.09-.485.193-.972.308-1.458 0 0 .102-.487.38-1.208Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M18 9.189c0 6.945.546 9.411 2.417 11.315 1.871 1.904 2.58 2.204 3.102 2.496.602-.337 1.296-.706 2.992-2.43C28.189 18.868 29 16.41 29 9.07c-1.22.53-1.828.705-2.895.702-.79.079-2.01-.436-2.739-.772-.476.308-1.168.676-2.41.717-1.434.06-1.889-.174-2.956-.529Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#C2E7FF",
      fillRule: "evenodd",
      d: "M27.653 19a6.307 6.307 0 0 1-1.142 1.57c-1.696 1.724-2.39 2.093-2.992 2.43-.522-.292-1.23-.592-3.102-2.496A6.513 6.513 0 0 1 19.297 19h8.356Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E87E04",
      fillRule: "evenodd",
      d: "M24.03 12.574c.228.58.959 1.22 1.16 1.534-.256.314-.307.28-.274.862.445-.503.453-.555.739-.479.626.676.112 2.128-.406 2.444-.517.336-.423-.012-1.2.41.356.329.769-.048 1.105.052.183.235-.087.663.056 1.066.297-.03.261-.68.33-.916.218-.863 1.525-1.466 1.592-2.257.275-.14.55-.044.886.16-.167-.742-.719-.734-.867-.966-.352-.582-.665-1.246-1.417-1.419-.571-.13-.528.04-.894-.23-.228-.192-.92-.555-.81-.26Zm-2.467 2.285c.39-.47.582-1.43.755-1.755.398.094.394.157.882-.136-.656-.183-.705-.166-.78-.464.275-.88 1.788-1.058 2.317-.724.549.324.2.395.95.918.109-.475-.422-.684-.501-1.039.113-.274.617-.218.896-.53-.174-.26-.72.066-.958.108-.856.188-2.025-.744-2.744-.45-.258-.19-.31-.486-.3-.886-.56.487-.28.991-.408 1.231-.33.585-.75 1.17-.528 1.94.17.584.296.468.244.926-.054.296-.026 1.095.175.861Zm3.373.674c-.645-.074-1.633.221-2.026.242-.13-.338-.071-.364-.607-.592.19.57.232.599 0 .79-.96.198-1.95-.841-1.931-1.387 0-.554.254-.328.326-1.123-.496.136-.399.625-.682.846-.313.042-.537-.358-.976-.422-.144.248.453.503.621.661.64.549.42 1.84 1.084 2.239-.035.278-.279.452-.652.627.753.193 1.064-.245 1.355-.26.718-.023 1.486.022 2.072-.495.445-.392.27-.433.72-.603.3-.095 1.02-.481.696-.523Z",
      clipRule: "evenodd"
    }
  )
), "SvgComponent"), SvgFlagAia = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagAia_default = SvgFlagAia;
export {
  FlagAia_default as default
};
